//React
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { ReactNode } from 'react';
//hooks
import useConfirmDialog from '../hooks/useConfirmDialog';
//components

type Props = {
    children : ReactNode
};

export default function GeneralConfirmDialog({ children } : Props)
{
    const { cancelDailog, confirmDialog, isOpen, text, cancelText, confirmText } = useConfirmDialog();
    return (
    <>
        {children}
        <Dialog open={isOpen}>
            <DialogTitle>Confirm</DialogTitle>
            <DialogContent>
                {text}
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" color="inherit" onClick={cancelDailog}>
                    {cancelText}
                </Button>
                <Button variant="contained" color="primary" onClick={confirmDialog}>{confirmText}</Button>
            </DialogActions>
        </Dialog>
    </>);
}